import awsconfig from "@/configs/aws-exports";
import "@/plugins/amplify-analytics";
import { Auth } from "@aws-amplify/auth";
import { Storage } from "@aws-amplify/storage";
Auth.configure(awsconfig.Auth);
Storage.configure(awsconfig.Storage);
